export default {"src":"/_next/static/media/kin.9844e9ad.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};